import * as API from "utils/api"
import HTTPStatus from "http-status"
import { push } from "react-router-redux"

const destroyCategoryRequest = () => ({
  type: "DESTROY_CATEGORY_REQUEST",
  auth: true,
})

const updateCategoryRequest = () => ({
  type: "UPDATE_CATEGORY_REQUEST",
  auth: true,
})

const createCategoryRequest = () => ({
  type: "CREATE_CATEGORY_REQUEST",
  auth: true,
})
const getCategoriesSuccess = categories => ({
  type: "GET_CATEGORIES_SUCCESS",
  categories,
})

const getCategoriesByCountySuccess = categories => ({
  type: "GET_CATEGORIES_BY_COUNTY_SUCCESS",
  categories,
})

const getCategorySuccess = category => ({
  type: "GET_CATEGORY_SUCCESS",
  category,
})

const destroyCategorySuccess = id => ({
  type: "DESTROY_CATEGORY_SUCCESS",
  id,
})

const createCategorySuccess = category => ({
  type: "CREATE_CATEGORY_SUCCESS",
  category,
})

const getCategoriesFailure = () => ({
  type: "GET_CATEGORIES_FAILURE",
})

const getCategoryFailure = () => ({
  type: "GET_CATEGORY_FAILURE",
})

const createCategoryFailure = () => ({
  type: "CREATE_CATEGORY_FAILURE",
})

const updateCategorySuccess = category => ({
  type: "UPDATE_CATEGORY_SUCCESS",
  category,
})

export const getCategories = () => async dispatch => {
  const response = await API.get("/categories")
  switch (response.status) {
    case HTTPStatus.OK:
      const categories = await response.json()
      dispatch(getCategoriesSuccess(categories))
      break
    default:
      dispatch(getCategoriesFailure())
  }
}

export const getCategory = id => async dispatch => {
  const response = await API.get(`/categories/${id}`)

  switch (response.status) {
    case HTTPStatus.OK:
      const category = await response.json()
      dispatch(getCategorySuccess(category))
      break
    default:
      dispatch(getCategoryFailure())
      break
  }
}
export const getCategoryByCounty = id => async dispatch => {
  const response = await API.get(`/counties/${id}/categories`)

  switch (response.status) {
    case HTTPStatus.OK:
      const categories = await response.json()
      dispatch(getCategoriesByCountySuccess(categories))
      break
    default:
      dispatch(getCategoriesFailure())
  }
}
export const createCategory = category => async dispatch => {
  dispatch(createCategoryRequest())
  const config = { body: JSON.stringify({ ...category }) }
  const response = await API.post("/categories", config)

  switch (response.status) {
    case HTTPStatus.CREATED:
      const createdCategory = await response.json()
      dispatch(createCategorySuccess(createdCategory))
      dispatch(push("/admin/categories"))
      break
    default:
      dispatch(createCategoryFailure())
      break
  }
}

export const destroyCategory = id => dispatch => {
  dispatch(destroyCategoryRequest())
  dispatch(destroyCategorySuccess(id))
  API.destroy(`/categories/${id}`)
}

export const updateCategory = (id, category) => async dispatch => {
  dispatch(updateCategoryRequest())
  const config = { body: JSON.stringify({ ...category }) }
  const response = await API.patch(`/categories/${id}`, config)
  const data = await response.json()

  dispatch(updateCategorySuccess(data))
  dispatch(push("/admin/categories"))
}



// WEBPACK FOOTER //
// src/data/categories/actions.js